export const FETCH_ALLERGEN = {
  START: 'START_FETCH_ALLERGEN',
  COMPLETE: 'COMPLETE_FETCH_ALLERGEN',
  FAIL: 'FAIL_FETCH_ALLERGEN',
  CLEANUP: 'CLEANUP_FETCH_ALLERGEN',
}

export const UPDATE_ALLERGEN_SIMPLE_DETAILS = {
  START: 'START_UPDATE_ALLERGEN_SIMPLE_DETAILS',
  COMPLETE: 'COMPLETE_UPDATE_ALLERGEN_SIMPLE_DETAILS',
  FAIL: 'FAIL_UPDATE_ALLERGEN_SIMPLE_DETAILS',
}

export const UPDATE_ALLERGEN_IMAGE_DETAILS = {
  START: 'START_UPDATE_ALLERGEN_IMAGE_DETAILS',
  COMPLETE: 'COMPLETE_UPDATE_ALLERGEN_IMAGE_DETAILS',
  FAIL: 'FAIL_UPDATE_ALLERGEN_IMAGE_DETAILS',
}

export const UPDATE_ALLERGEN_EXCLUDED_ALLERGENS_DETAILS = {
  START: 'START_UPDATE_ALLERGEN_EXCLUDED_ALLERGENS_DETAILS',
  COMPLETE: 'COMPLETE_UPDATE_ALLERGEN_EXCLUDED_ALLERGENS_DETAILS',
  FAIL: 'FAIL_UPDATE_ALLERGEN_EXCLUDED_ALLERGENS_DETAILS',
}

export const UPDATE_ALLERGEN_EXCLUDED_INGREDIENTS_DETAILS = {
  START: 'START_UPDATE_ALLERGEN_EXCLUDED_INGREDIENTS_DETAILS',
  COMPLETE: 'COMPLETE_UPDATE_ALLERGEN_EXCLUDED_INGREDIENTS_DETAILS',
  FAIL: 'FAIL_UPDATE_ALLERGEN_EXCLUDED_INGREDIENTS_DETAILS',
}

export const SET_ALLERGEN_PAGE_TO_DIRTY = 'SET_ALLERGEN_PAGE_TO_DIRTY'
